import { createContext } from "react";
import type { Status } from "types/Status";

const ExercisesContextStatus = createContext<Status | undefined>(undefined);
ExercisesContextStatus.displayName = "ExercisesContextStatus";

export default ExercisesContextStatus;
